/* tslint:disable */
/* eslint-disable */
/**
 * UPM-metsa-api
 * UPM Metsä API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalizedValue,
    LocalizedValueFromJSON,
    LocalizedValueFromJSONTyped,
    LocalizedValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface TreeSpecies
 */
export interface TreeSpecies {
    /**
     * 
     * @type {string}
     * @memberof TreeSpecies
     */
    readonly id?: string;
    /**
     * 
     * @type {Array<LocalizedValue>}
     * @memberof TreeSpecies
     */
    name: Array<LocalizedValue>;
    /**
     * Tree species code
     * @type {string}
     * @memberof TreeSpecies
     */
    code?: string;
}

export function TreeSpeciesFromJSON(json: any): TreeSpecies {
    return TreeSpeciesFromJSONTyped(json, false);
}

export function TreeSpeciesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TreeSpecies {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': ((json['name'] as Array<any>).map(LocalizedValueFromJSON)),
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function TreeSpeciesToJSON(value?: TreeSpecies | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': ((value.name as Array<any>).map(LocalizedValueToJSON)),
        'code': value.code,
    };
}


